// extracted by mini-css-extract-plugin
export default {"root":"_2oFzHKKb","steady":"_22ycPi8Y","absolute":"_2SBiKv5G","icon":"_2YmLThnR","badge":"_1RH20-QW"};